export enum BannerType {
    System = 1,
    Contextual = 2,
    Inline = 3
  }